import React from 'react'

import { COLOR } from '../../../../themes'

const RepeatEndRadio = ({ isSelected, value, onSelected }) => {
  const color = isSelected ? COLOR.GOLD_1 : COLOR.WHITE

  return (
    <div className='radio-layout' onClick={onSelected}>
      <input
        style={{ color }}
        type='radio'
        value={value}
        checked={isSelected}
        readOnly
      />
      <label className='radio-option'>{value}</label>
    </div>
  )
}

export default RepeatEndRadio
